import { EndCustomerDto } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { Operations } from '../operations.entity';
import { OperationDTO } from './operations.dto';
// import { Address } from '../address.entity';
// import { EndCustomers } from '../endCustomer.entity';
// import { EndCustomerDTO } from './endCustomer.dto';


@Injectable()
export class OperationsAdapter {
  /**
   *
   * @param operationDTO
   * @returns Operations entity
   */
  public convertDtoToEntity(  operationDTO: OperationDTO,  isUpdate: boolean = false ): Operations {
    const operation = new Operations();
    operation.operationId=operationDTO.operationId;
    operation.operationCode=operationDTO.operationCode;
    operation.operationName=operationDTO.operationName;
    operation.workstationCategoryId=operationDTO.workstationCategoryId;
    operation.isValueAddition=operationDTO.isValueAddition;
    operation.isActive=operationDTO.isActive==undefined?true:operationDTO.isActive;
    // endCustomer.currencyInfo = endCustomersDTO.currenciesInfo;
    
    if (isUpdate) {
        operation.updatedUser = operationDTO.updatedUser;
    } else {
        operation.isActive = true;
        operation.createdUser = operationDTO.createdUser;
    }

   return operation;
  }
  /**
   * 
   * @param operationObject Operations entity
   * @returns OperationDTO
   */
  public convertEntityToDto(operationObject: Operations): OperationDTO {
    const operationDTO = new OperationDTO;
    operationDTO.operationId = operationObject.operationId;
    operationDTO.operationCode = operationObject.operationCode;
    operationDTO.operationName = operationObject.operationName;
    operationDTO.workstationCategoryId = operationObject.workstationCategoryId;
    operationDTO.isValueAddition = operationObject.isValueAddition;
    operationDTO.isActive = operationObject.isActive;
    operationDTO.createdAt = operationObject.createdAt;
    operationDTO.updatedAt = operationObject.updatedAt;
    operationDTO.createdUser = operationObject.createdUser;
    operationDTO.updatedUser = operationObject.updatedUser;
    operationDTO.versionFlag = operationObject.versionFlag;
    operationDTO.workstationCategoryInfo = operationObject.workstationCategoryInfo;
    
    return operationDTO;
  }
}
